import angular from 'angular'
import ggsUtils from '../../utils'
import ggsImgQueue from '../../ggs-img-queue'
import ggsRecalcOnevent from '../../ggs-recalc-onevent'

export default angular
  .module('ggs.gallery-broken', [
    ggsUtils,
    ggsImgQueue,
    ggsRecalcOnevent
  ])
  .name
